// this file was generated by bin/generate-image-imports.js during "npm run build"
// it lists all import lines of images in app/javascript/images at the time of build
// you can ignore this file, it only needs to be included in your entrypoint
globalThis.__images ||= [];
import __import_image_0 from './images/avatar/VET-MAGAZIN-200x200.png';
globalThis.__images.push(__import_image_0);
import __import_image_1 from './images/avatar/auto-motor-at-200x200.png';
globalThis.__images.push(__import_image_1);
import __import_image_2 from './images/logos/VET-MAGAZIN-Logo-at-475.png';
globalThis.__images.push(__import_image_2);
import __import_image_3 from './images/logos/VET-MAGAZIN-Logo-ch-475.png';
globalThis.__images.push(__import_image_3);
import __import_image_4 from './images/logos/VET-MAGAZIN-Logo-com-475.png';
globalThis.__images.push(__import_image_4);
import __import_image_5 from './images/logos/VET-MAGAZIN-Logo-de-475.png';
globalThis.__images.push(__import_image_5);
import __import_image_6 from './images/logos/VET-MAGAZIN-Logo-es-475.png';
globalThis.__images.push(__import_image_6);
import __import_image_7 from './images/logos/VET-MAGAZIN-Logo-hr-475.png';
globalThis.__images.push(__import_image_7);
import __import_image_8 from './images/logos/VET-MAGAZIN-Logo-ro-475.png';
globalThis.__images.push(__import_image_8);
import __import_image_9 from './images/logos/VET-MAGAZIN-Logo-si-475.png';
globalThis.__images.push(__import_image_9);
import __import_image_10 from './images/logos/VM-VPP-privacy-manager.png';
globalThis.__images.push(__import_image_10);
import __import_image_11 from './images/logos/vet-passport-logo-500.png';
globalThis.__images.push(__import_image_11);
import __import_image_12 from './images/social-share-button/delicious.svg';
globalThis.__images.push(__import_image_12);
import __import_image_13 from './images/social-share-button/douban.svg';
globalThis.__images.push(__import_image_13);
import __import_image_14 from './images/social-share-button/email.svg';
globalThis.__images.push(__import_image_14);
import __import_image_15 from './images/social-share-button/facebook.svg';
globalThis.__images.push(__import_image_15);
import __import_image_16 from './images/social-share-button/google_bookmark.svg';
globalThis.__images.push(__import_image_16);
import __import_image_17 from './images/social-share-button/hacker_news.svg';
globalThis.__images.push(__import_image_17);
import __import_image_18 from './images/social-share-button/linkedin.svg';
globalThis.__images.push(__import_image_18);
import __import_image_19 from './images/social-share-button/odnoklassniki.svg';
globalThis.__images.push(__import_image_19);
import __import_image_20 from './images/social-share-button/pinterest.svg';
globalThis.__images.push(__import_image_20);
import __import_image_21 from './images/social-share-button/qq.svg';
globalThis.__images.push(__import_image_21);
import __import_image_22 from './images/social-share-button/reddit.svg';
globalThis.__images.push(__import_image_22);
import __import_image_23 from './images/social-share-button/telegram.svg';
globalThis.__images.push(__import_image_23);
import __import_image_24 from './images/social-share-button/tumblr.svg';
globalThis.__images.push(__import_image_24);
import __import_image_25 from './images/social-share-button/twitter.svg';
globalThis.__images.push(__import_image_25);
import __import_image_26 from './images/social-share-button/vkontakte.svg';
globalThis.__images.push(__import_image_26);
import __import_image_27 from './images/social-share-button/wechat.svg';
globalThis.__images.push(__import_image_27);
import __import_image_28 from './images/social-share-button/weibo.svg';
globalThis.__images.push(__import_image_28);
import __import_image_29 from './images/social-share-button/whatsapp.svg';
globalThis.__images.push(__import_image_29);
import __import_image_30 from './images/social-share-button/xing.svg';
globalThis.__images.push(__import_image_30);
import __import_image_31 from './images/backgrounds/vintage-pattern.png';
globalThis.__images.push(__import_image_31);
import __import_image_32 from './images/sponsors/anicura-300.png';
globalThis.__images.push(__import_image_32);
import __import_image_33 from './images/sponsors/animalis-300.png';
globalThis.__images.push(__import_image_33);
import __import_image_34 from './images/sponsors/biogena-300.png';
globalThis.__images.push(__import_image_34);
import __import_image_35 from './images/sponsors/boehringer_ingelheim-300.png';
globalThis.__images.push(__import_image_35);
import __import_image_36 from './images/sponsors/btl_petshop-300.png';
globalThis.__images.push(__import_image_36);
import __import_image_37 from './images/sponsors/elanco-300.png';
globalThis.__images.push(__import_image_37);
import __import_image_38 from './images/sponsors/felivet-300.png';
globalThis.__images.push(__import_image_38);
import __import_image_39 from './images/sponsors/feragen-300.png';
globalThis.__images.push(__import_image_39);
import __import_image_40 from './images/sponsors/feragen-en-300.png';
globalThis.__images.push(__import_image_40);
import __import_image_41 from './images/sponsors/graeub-300.png';
globalThis.__images.push(__import_image_41);
import __import_image_42 from './images/sponsors/happy_cat-300.png';
globalThis.__images.push(__import_image_42);
import __import_image_43 from './images/sponsors/happy_dog-300.png';
globalThis.__images.push(__import_image_43);
import __import_image_44 from './images/sponsors/heel-300.png';
globalThis.__images.push(__import_image_44);
import __import_image_45 from './images/sponsors/hipra-300.png';
globalThis.__images.push(__import_image_45);
import __import_image_46 from './images/sponsors/iris-300.png';
globalThis.__images.push(__import_image_46);
import __import_image_47 from './images/sponsors/laboklin-300.png';
globalThis.__images.push(__import_image_47);
import __import_image_48 from './images/sponsors/medical_intertrade-300.png';
globalThis.__images.push(__import_image_48);
import __import_image_49 from './images/sponsors/melisa_veterina-300.png';
globalThis.__images.push(__import_image_49);
import __import_image_50 from './images/sponsors/msd-300.png';
globalThis.__images.push(__import_image_50);
import __import_image_51 from './images/sponsors/newvetline-300.png';
globalThis.__images.push(__import_image_51);
import __import_image_52 from './images/sponsors/purina-300.png';
globalThis.__images.push(__import_image_52);
import __import_image_53 from './images/sponsors/rauberger-300.png';
globalThis.__images.push(__import_image_53);
import __import_image_54 from './images/sponsors/richter_pharma-300.png';
globalThis.__images.push(__import_image_54);
import __import_image_55 from './images/sponsors/royal_canin-300.png';
globalThis.__images.push(__import_image_55);
import __import_image_56 from './images/sponsors/salus-300.png';
globalThis.__images.push(__import_image_56);
import __import_image_57 from './images/sponsors/tao-300.png';
globalThis.__images.push(__import_image_57);
import __import_image_58 from './images/sponsors/ultraschall_akademie-300.png';
globalThis.__images.push(__import_image_58);
import __import_image_59 from './images/sponsors/vet_coaching-300.png';
globalThis.__images.push(__import_image_59);
import __import_image_60 from './images/sponsors/vet_concept-300.png';
globalThis.__images.push(__import_image_60);
import __import_image_61 from './images/sponsors/vetconsult_pharma-300.png';
globalThis.__images.push(__import_image_61);
import __import_image_62 from './images/sponsors/vetline-300.png';
globalThis.__images.push(__import_image_62);
import __import_image_63 from './images/sponsors/vetnordic-300.png';
globalThis.__images.push(__import_image_63);
import __import_image_64 from './images/sponsors/vetpromet-300.png';
globalThis.__images.push(__import_image_64);
import __import_image_65 from './images/sponsors/vetscan_diagnostika-300.png';
globalThis.__images.push(__import_image_65);
import __import_image_66 from './images/sponsors/vetviva-300.png';
globalThis.__images.push(__import_image_66);
import __import_image_67 from './images/sponsors/virbac-300.png';
globalThis.__images.push(__import_image_67);
import __import_image_68 from './images/sponsors/vzb-300.png';
globalThis.__images.push(__import_image_68);
import __import_image_69 from './images/sponsors/wdt-300.png';
globalThis.__images.push(__import_image_69);
import __import_image_70 from './images/sponsors/zoetis-300.png';
globalThis.__images.push(__import_image_70);
import __import_image_71 from './images/system/error.jpg';
globalThis.__images.push(__import_image_71);
import __import_image_72 from './images/system/forbidden.jpg';
globalThis.__images.push(__import_image_72);
import __import_image_73 from './images/system/not_found.jpg';
globalThis.__images.push(__import_image_73);
import __import_image_74 from './images/favicons/120.png';
globalThis.__images.push(__import_image_74);
import __import_image_75 from './images/favicons/128.png';
globalThis.__images.push(__import_image_75);
import __import_image_76 from './images/favicons/144.png';
globalThis.__images.push(__import_image_76);
import __import_image_77 from './images/favicons/150.png';
globalThis.__images.push(__import_image_77);
import __import_image_78 from './images/favicons/152.png';
globalThis.__images.push(__import_image_78);
import __import_image_79 from './images/favicons/180.png';
globalThis.__images.push(__import_image_79);
import __import_image_80 from './images/favicons/192.png';
globalThis.__images.push(__import_image_80);
import __import_image_81 from './images/favicons/196.png';
globalThis.__images.push(__import_image_81);
import __import_image_82 from './images/favicons/228.png';
globalThis.__images.push(__import_image_82);
import __import_image_83 from './images/favicons/32.png';
globalThis.__images.push(__import_image_83);
import __import_image_84 from './images/favicons/57.png';
globalThis.__images.push(__import_image_84);
import __import_image_85 from './images/favicons/70.png';
globalThis.__images.push(__import_image_85);
import __import_image_86 from './images/favicons/76.png';
globalThis.__images.push(__import_image_86);
import __import_image_87 from './images/favicons/96.png';
globalThis.__images.push(__import_image_87);
import __import_image_88 from './images/favicons/favicon.ico';
globalThis.__images.push(__import_image_88);
